import { render, staticRenderFns } from "./MenuItemOption.vue?vue&type=template&id=66296ed9&scoped=true&"
import script from "./MenuItemOption.vue?vue&type=script&lang=js&"
export * from "./MenuItemOption.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemOption.vue?vue&type=style&index=0&id=66296ed9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66296ed9",
  null
  
)

export default component.exports